import React from 'react';
import queryString from 'query-string';
import { Row, Col, Glyphicon } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Box, Button } from 'fw/components';
import { TextBox, Form } from 'fw/forms'
import Result from './Result'
import * as Recent from 'modules/app/Recent';
import * as API from 'modules/app/API'
import * as App from 'modules/app/App';
import * as Notifications from 'fw/globals/Notifications';

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            searching: true,
            results: [],
            totalCount: 0,
            pageSize: 100,
            pageIndex: 0,
            form: {
                query: queryString.parse(this.props.location.search).p
            }
        }
    }

    search = () => {
        const me = this;
        let userTypeCode = App.context().userTypeCode;

        var rq = {
            query: this.state.form.query,
            inactive: userTypeCode !== 'CER' && userTypeCode !== 'SPN'
        }

        API.Search.get('/search', rq,
            {
                success: (r) => {
                    me.searchBox.select();

                    this.setState({
                        searching: false,
                        query: rq.query,
                        results: r.data.items,
                        totalCount: r.data.totalCount,
                        totalSeconds: r.data.totalSeconds
                    });

                    me.addRecent(rq.query);
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                    this.setState({
                        searching: false
                    });
                }
            });
    }

    addRecent = (query) => {
        Recent.add({
            activityTitle: query,
            recentType: "search",
            entityKey: query
        });
    }

    nextPage = () => {
        this.setState({ pageIndex: this.state.pageIndex + 1 }, function () {
            this.search()
        });
    }

    onChange = (form) => {
        this.setState({ form });
    }

    onSubmit = (form) => {
        this.props.history.push('/search?p=' + this.state.form.query);
        this.search();
        return false;
    }

    componentWillReceiveProps(nextProps) {
        let currentP = queryString.parse(this.props.location.search).p;
        let nextP = queryString.parse(nextProps.location.search).p;

        if (nextP !== currentP) {
            this.setState({ form: { query: nextP } }, () => {
                this.search();
            });
        }
    }

    componentDidMount() {
        this.search();
    }

    render() {
        const results = this.state.results.map((r, i) =>
            <div key={i}>
                <Result result={r} />
            </div>
        );

        return (
            <React.Fragment>
                <ContentHeader title="Global search" description="Your own mini Google.">
                </ContentHeader>
                <ContentBody>
                    <Box>
                        <Form
                            onChange={this.onChange}
                            values={this.state.form}
                            onSubmit={this.onSubmit}>
                            <TextBox name="query" maxLength={128} placeholder="Search text..." ref={(c) => { this.searchBox = c; }} />
                            <br />
                            <hr />
                        </Form>
                        <Row>
                            <Col md={11}>
                                <div>
                                    {this.state.searching &&
                                        <div className="text-center" style={{ height: "300px" }}>
                                            <h4>Searching, one moment please...</h4>
                                            <br />
                                            <img src="/images/loading.gif" alt="" />
                                        </div>
                                    }
                                    {!this.state.searching && this.state.results.length === 0 &&
                                        <div>
                                            <p>There are no results.</p>
                                        </div>
                                    }
                                    {!this.state.searching && this.state.results.length > 0 &&
                                        <div>
                                            <Row>
                                                <Col md={12}>
                                                    <span className="search-total">About {this.state.totalCount} results ({this.state.totalSeconds} seconds)</span>
                                                    <div style={{ marginTop: "15px" }}>{results}</div>
                                                </Col>
                                            </Row>
                                            <br />
                                            {false && this.state.totalCount > ((this.state.pageIndex + 1) * this.state.pageSize) &&
                                                <Row>
                                                    <Col md={12}>
                                                        <Button id="btnViewMoreResults" className="pull-right" onClick={this.onLoadMoreResults}><Glyphicon glyph="glyphicon glyphicon-repeat" style={{ marginRight: 10 }} />Show more results</Button>
                                                    </Col>
                                                </Row>
                                            }
                                        </div>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Box>
                </ContentBody>
            </React.Fragment>
        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/main/search/Search.js